import type { WithdrawalAccount } from 'api';
import { Restricted } from 'containers/Restricted';

import { CreateWithdrawalButton } from './CreateWithdrawalButton';
import type { FiltersState } from './localState';
import { WithdrawalFilters } from './WithdrawalFilters';

type Props = {
  filters: FiltersState;
  setFilters: (value: FiltersState) => void;
  resetState: () => void;
  withdrawalAccounts: WithdrawalAccount[];
  isWithdrawalAccountsError: boolean;
  isWithdrawalAccountsLoading: boolean;
};

export const WithdrawalsHeader = ({
  filters,
  setFilters,
  resetState,
  withdrawalAccounts,
  isWithdrawalAccountsError,
  isWithdrawalAccountsLoading
}: Props) => {
  return (
    <div className="w-full items-center">
      <div className="mb-6 flex h-10 w-full flex-row justify-between">
        <div className="text-2xl font-medium">Withdrawals</div>
        <Restricted requiredPermission="withdrawals:manage">
          <CreateWithdrawalButton
            withdrawalAccounts={withdrawalAccounts}
            isWithdrawalAccountsError={isWithdrawalAccountsError}
            isWithdrawalAccountsLoading={isWithdrawalAccountsLoading}
          />
        </Restricted>
      </div>
      <WithdrawalFilters
        filters={filters}
        setFilters={setFilters}
        resetState={resetState}
      />
    </div>
  );
};
